import { PcbNodeTypes } from "@buildwithflux/models";
import { MissingChildUidError } from "../../../../../../flux_error";
import { getChildByName } from "../../../../../../nodes";
export function getExistingPadNodes(nodeData, pcbLayoutNodes, logger) {
    const padsNode = getChildByName(pcbLayoutNodes, nodeData.uid, "Pads", logger);
    if (!padsNode) {
        return;
    }
    // NOTE: We play safe here to fallback childUids to empty, but want to know
    // that childUids is missing, so that we can investigate and take actions from here
    if (!padsNode.childUids && "captureError" in logger) {
        logger.captureError(new MissingChildUidError(`node ${padsNode.uid} with type ${padsNode.type} in getExistingPadNodes`));
    }
    return (padsNode.childUids || [])
        .map((uid) => pcbLayoutNodes[uid])
        .filter((node) => node?.type === PcbNodeTypes.pad);
}
//# sourceMappingURL=getExistingPadNodes.js.map